import SearchError from './SearchError';

export default SearchError;
